// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__AJUzT","title":"Header_title__3hkqv","side":"Header_side__2lREd"};